// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"selectMultipleCards_dropdown__1IN5G","menu":"selectMultipleCards_menu__F_8Xv"};